var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 7.41667C12.75 10.3622 10.3622 12.75 7.41667 12.75M12.75 7.41667C12.75 4.47115 10.3622 2.08333 7.41667 2.08333M12.75 7.41667H14.0833M7.41667 12.75C4.47115 12.75 2.08333 10.3622 2.08333 7.41667M7.41667 12.75V14.0833M7.41667 2.08333C4.47115 2.08333 2.08333 4.47115 2.08333 7.41667M7.41667 2.08333V0.75M2.08333 7.41667H0.75M9.41667 7.41667C9.41667 8.52127 8.52127 9.41667 7.41667 9.41667C6.31207 9.41667 5.41667 8.52127 5.41667 7.41667C5.41667 6.31207 6.31207 5.41667 7.41667 5.41667C8.52127 5.41667 9.41667 6.31207 9.41667 7.41667Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.f6fde9c9b9c63fb55f545dce5d4f838f.svg";
export { ForwardRef as ReactComponent };